// mapeia tipos de ação para rótulos em pt-BR
export function mapActionType(
  translate: (item: string) => string,
  requestType?: { readonly type?: 'CREATE' | 'EDIT' | 'DELETE' | string }
): string {
  const raw = String(requestType?.type || '').toUpperCase()

  if (raw === 'CREATE' || raw === 'POST') return translate('CREATE')
  // aceitar 'PUT' e variações como 'UPDATE'
  if (raw === 'PUT' || raw === 'UPDATE') return translate('EDIT')
  // aceitar 'DELETE' e variações como 'REMOVED'
  if (raw === 'DELETE' || raw === 'REMOVED') return translate('DELETE')

  return raw ? raw : ''
}

export function buildReportTypeOptions(translate: (item: string) => string) {
  return [
    { value: 'synthetical', label: translate('synthetic') },
    { value: 'complete', label: translate('complete') },
    { value: 'by_vehicle', label: translate('By vehicle') },
    { value: 'by_people', label: translate('By people') },
    { value: 'by_drugs', label: translate('By drugs') },
    { value: 'by_weapon', label: translate('By weapon') },
    { value: 'by_object', label: translate('By object') },
    { value: 'by_animal', label: translate('By animal') },
    { value: 'by_organization', label: translate('By organization') },
  ]
}

const routeToTypeMap: Record<string, string> = {
  '/dispatch/csv/synthetical': 'synthetical',
  '/dispatch/csv/complete': 'complete',
  '/occurrence/associated-vehicle/generate-csv': 'by_vehicle',
  '/occurrence/associated-people/generate-csv': 'by_people',
  '/occurrence/associated-drugs/generate-csv': 'by_drugs',
  '/occurrence/associated-weapon/generate-csv': 'by_weapon',
  '/occurrence/associated-object/generate-csv': 'by_object',
  '/occurrence/associated-organization/generate-csv': 'by_organization',
  '/occurrence/associated-animal/generate-csv': 'by_animal',
}

export function mapRouteToReportTypeLabel(
  translate: (item: string) => string,
  route: string
): string {
  const type = routeToTypeMap[route]
  if (type) {
    const options = buildReportTypeOptions(translate)
    const option = options.find((opt) => opt.value === type)
    return option ? option.label : route
  }
  return route
}
